import { render, staticRenderFns } from "./DutyEdit.vue?vue&type=template&id=9b256b3e&"
import script from "./DutyEdit.vue?vue&type=script&lang=js&"
export * from "./DutyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports